/* BLOB Relaunch 2026 – In den Warenkorb ohne Seitenwechsel */
(function () {
  if (window.__blobInit) return;
  window.__blobInit = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var toast, text, timer;
  function ensureToast() {
    if (toast) return;
    toast = document.createElement('div');
    toast.className = 'bl-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    text = document.createElement('span');
    var link = document.createElement('a');
    link.href = root + 'cart';
    link.textContent = 'Zum Warenkorb';
    toast.appendChild(text);
    toast.appendChild(link);
    document.body.appendChild(toast);
  }
  function show(msg) {
    ensureToast();
    text.textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(timer);
    timer = setTimeout(function () { toast.classList.remove('is-on'); }, 4000);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form.bl-add');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Wird hinzugefügt …';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (data) {
        var title = (data.items && data.items[0] && data.items[0].product_title) || 'Cap';
        show(title + ' ist im Warenkorb');
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
        if (bubbles.length) {
          bubbles.forEach(function (el) { el.textContent = cart.item_count; });
        } else {
          var icon = document.getElementById('cart-icon-bubble');
          if (icon) {
            var b = document.createElement('div');
            b.className = 'cart-count-bubble';
            b.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
            icon.appendChild(b);
          }
        }
      })
      .catch(function () { show('Das hat nicht geklappt. Bitte versuch es noch einmal.'); })
      .finally(function () { btn.disabled = false; btn.textContent = label; });
  });
})();
